import React from 'react';

import { FormStep } from 'components/FormWithSteps/FormStep';

import { QrCodePix } from './QrCode';
import { Container } from './styles';

export const Pix: React.FC = () => {

  return (
    <Container>
        <FormStep>
          <QrCodePix />
        </FormStep>
    </Container>
  );
};
